"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ViewWorkHeader_1 = __importDefault(require("@Components/ViewWork/Headers/ViewWorkHeader"));
require("./index.scss");
const dayjs_1 = __importDefault(require("dayjs"));
const RegHistoryWorkHeader = (props) => (react_1.default.createElement(ViewWorkHeader_1.default, { work: props.work },
    react_1.default.createElement("div", { className: 'sub-data' }, props.work.submissionDate && (react_1.default.createElement("div", null,
        "Submission Date:",
        react_1.default.createElement("span", { className: 'bold' }, props.work.submissionDate &&
            (0, dayjs_1.default)(props.work.submissionDate, 'YYYY-MM-DD')
                .toDate()
                .toLocaleString('default', { month: 'long', day: '2-digit', year: 'numeric' })))))));
exports.default = RegHistoryWorkHeader;
